/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Cooperationcontractsenton3Inputs */

const de__field_cooperationcontractsenton3 = /** @type {(inputs: _Field_Cooperationcontractsenton3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rahmenvereinbarung gesendet am`)
};

/**

* @param {_Field_Cooperationcontractsenton3Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_cooperationcontractsenton3 = /** @type {((inputs?: _Field_Cooperationcontractsenton3Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Cooperationcontractsenton3Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_cooperationcontractsenton3(inputs)
});
export { _field_cooperationcontractsenton3 as "_field_cooperationContractSentOn" }